var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOmega(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M448 440C448 462.094 430.094 480 408 480H296C273.906 480 256 462.094 256 440V407.562C256 391.844 265.219 377.562 279.547 371.094C328.422 349.062 360 300.719 360 248C360 173 298.984 112 224 112S88 173 88 248C88 300.719 119.578 349.062 168.453 371.094C182.781 377.562 192 391.844 192 407.562V440C192 462.094 174.094 480 152 480H40C17.906 480 0 462.094 0 440S17.906 400 40 400H71.625C31.656 360.25 8 305.812 8 248C8 128.906 104.891 32 224 32S440 128.906 440 248C440 305.812 416.344 360.25 376.375 400H408C430.094 400 448 417.906 448 440Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOmega);
export default __webpack_public_path__ + "static/media/omega.01d4520b23c1cb0023e200bc99a4a652.svg";
export { ForwardRef as ReactComponent };